// extracted by mini-css-extract-plugin
export default {"switch":"switcher_switch__VAjjd","checkedValue":"switcher_checkedValue__oz8NA"};